<template>
  <div class="card">
    <div class="top">
      <img class="avatarImg" :src="userInfo.headUrl || avatarImg" />
      <div>
        <div class="flex-line-center">
          <span class="username">{{ userInfo.name }}</span>
          <span class="label mr-8">{{ userInfo.username }}</span>
          <!-- 游客状态不展示 -->
          <span :class="[userInfo.userType === '1' ? 'managerTag' : 'engineerTag']"
            v-if="[1, 2].includes(+userInfo.userType)">{{ ["-", "管理员",
              "工程师"][+userInfo.userType] }}</span>
        </div>
        <div class="label ellipsis">{{ userInfo.companyName }}</div>
      </div>
    </div>
    <div class="info">
      <div>
        <span class="label">报工单：</span>
        <span class="value">{{ userInfo.supplierOrderCount || 0 }}单</span>
      </div>
      <div>
        <span class="label">结算单：</span>
        <span class="value">{{ userInfo.settleCount || 0 }}单</span>
      </div>
      <!-- 在管理员身份时展示 -->
      <div v-if="userInfo.userType === '1'">
        <span class="label">管理员：</span>
        <span class="value">{{ userInfo.adminStr || 0 }}位</span>
      </div>
      <!-- 在管理员身份时展示 -->
      <div v-if="userInfo.userType === '1'">
        <span class="label">工程师：</span>
        <span class="value">{{ userInfo.engineerCount || 0 }}位</span>
      </div>
      <!-- 在工程师身份时展示 -->
      <div v-if="userInfo.userType === '2'">
        <span class="label">管理员：</span>
        <span class="value">{{ userInfo.adminStr }}</span>
      </div>
      <el-tooltip class="multi_line" effect="dark" placement="top" :disabled="!tagList || !tagList.length">
        <div slot="content" style="max-width: 600px; min-width: 30px">
          {{ (tagList || []).join(",") }}
        </div>
        <div :class="[userInfo.userType === '1' ? 'ellipsis' : 'multi_line_overflow']">
          <span class="label">个人能力：</span>
          <span v-for="(item, index) in tagList" :key="index" class="tag">{{
            item
          }}</span>
        </div>
      </el-tooltip>
      <el-tooltip class="multi_line" effect="dark" placement="top" :disabled="!supplierTagList || !supplierTagList.length">
        <div slot="content" style="max-width: 600px; min-width: 30px">
          {{ (supplierTagList || []).join(",") }}
        </div>
        <div class="ellipsis">
          <span class="label">企业能力：</span>
          <span v-for="(item, index) in supplierTagList" :key="index" class="tag">{{
            item
          }}</span>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import avatarImg from "@/assets/img/icon.jpg";

export default {
  data() {
    return {
      avatarImg,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.ecology.userInfo || {};
    },
    tagList() {
      return this.$store.state.ecology.userInfo ? (this.$store.state.ecology.userInfo.abilityList || []) : [];
    },
    supplierTagList() {
      return this.$store.state.ecology.userInfo ? (this.$store.state.ecology.userInfo.supplierAbilityList || []) : [];
    }
  },
  created() {
    this.getEcologyUserInfo()
    this.getCorpUser();
  },
  methods: {
    getEcologyUserInfo() {
      if (!this.userInfo.userId) {
        return
      }
      return this.$http
        .get(`/front/oms/supplier/User/getSsoUserInfoByUserId/${this.userInfo.userId}`)
        .then(({ data: res }) => {
          if (res.code == 0) {
            // 手动修改用户类型
            // res.data.userType = 2
            this.$store.commit("setEcologyUserInfo", res.data);
          }
        });
    },
    getCorpUser() {
      return this.$http
        .get("/front/sys/crop-site/customer-crop-site")
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$store.commit("setCorpUserInfo", res.data || {});
          }
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.card {
  background: #fff;
  padding: 10px 20px;
  width: 360px;
  height: 254px;
}

.top {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
}

.avatarImg {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #7394f6;
  margin-right: 16px;
}

.txt {
  font-family: Alibaba PuHuiTi;
  font-size: 14px;
}

.label {
  @extend .txt;
  color: #666666;
}

.value {
  @extend .txt;
  color: #333333;
  word-break: break-all;
}

.tag {
  height: 19px;
  border-radius: 17px;
  padding: 1px 8px;
  font-family: Alibaba PuHuiTi;
  font-size: 12px;
  color: #fff;
  background: #2a54d1;
  margin-right: 4px;
  margin-bottom: 4px;
  display: inline-block;
}

.userTag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 17px;
  background: linear-gradient(292deg, #2a54d1 0%, #85a4ff 100%);
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: #fff;
  font-size: 12px;
}

.managerTag {
  @extend .userTag;
  background: linear-gradient(292deg, #e5a92f 0%, #ffd37a 100%);
}

.engineerTag {
  @extend .userTag;
  background: linear-gradient(292deg, #2a54d1 0%, #85a4ff 100%);
}

.mr-8 {
  margin-right: 8px;
}

.info {
  padding-left: 4px;
  padding-right: 4px;

  &>div {
    margin-top: 6px;
  }
}

.multi_line {
  margin-top: 6px;
}

.username {
  @extend .txt;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  max-width: 86px;
  margin-right: 8px;
  display: inline-block;
}

.flex-line-center {
  display: flex;
  align-items: center;
}
</style>